import { IGetEntregaPesquisaSatisfacaoByIdUseCase } from "../../../presentation/useCases/read/get_entrega_pesquisa_satisfacao_by_id_use_case";
import { EntregaObraPesquisaSatisfacao } from "../../models/entrega_obra_pesquisa_satisfacao";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaPesquisaSatisfacaoByIdUseCase
 */

export class GetEntregaPesquisaSatisfacaoByIdUseCase implements IGetEntregaPesquisaSatisfacaoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaPesquisa: number): Promise<EntregaObraPesquisaSatisfacao> {
    return await this.repository.getEntregaPesquisaSatisfacaoById(idEntregaPesquisa);

  }
}
